import "./instrument.ts";
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import * as React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { ApolloProvider } from "./providers/ApolloProvider";
import { ThemeProvider } from "./providers/ThemeProvider.tsx";
import "./index.css";

loadDevMessages();
loadErrorMessages();

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

createRoot(root).render(
  <React.StrictMode>
    <ApolloProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
